<!-- 批量管理 -->
<template>
    <div class="container">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 批量管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <e-search
      :data="filterInfo.data"
      :field-list="filterInfo.fieldList"
      :list-type-info="listTypeInfo"
      @handleFilter="handleFilter"
      @handleReset="handleReset"
      @handleEvent="handleEvent"></e-search>
    <div class="container">
      <div class="handle-box">
        <table-list
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        :table-option="tableOption"
        @handleButton="handleButton"
        @handleSortChange="handleSortChange"
        @handleSelectionChange="handleSelectionChange">
        <!-- eslint-disable-next-line -->
       <template v-slot:company="slot">
            <img class="sku-img" src="https://t7.baidu.com/it/u=3038817810,32670274&fm=193&f=GIF" alt="">
        </template>
      </table-list>
        <div class="pagination">
          <el-pagination

            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="productTagPage.currentPage"
            :page-size="productTagPage.pageSize"
            :total="productTagPage.pageTotal"
            prev-text="上一页"
            next-text="下一页"
          >
          </el-pagination>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import eSearch from "../../components/common/e-search";
import tableList from "@/components/common/table-list"
export default {
  data () {
    return {
          tableData:[{id:1,company:'1',status:0},{id:2,company:'2',status:1}],
      tableLabel: [
        { label: '文件名称', param: 'email', align: 'center', },
        { label: '类型', param: 'company', align: 'center' ,slot:'company'},
        { label: '处理状态', param: 'status', align: 'center', render:  (row) => {
            if (row.status === 0) {
              return '<h3>未审核</h3>'
            } else if (row.status === 1) {
              return '审核通过'
            } else if(row.status ===2) {
              return '审核不通过'
            } else {
              return '禁用'
            }
          }
        },
        { label: '处理数量', param: 'registTime', align: 'center' },
        { label: '处理成功数量', param: 'registTime', align: 'center' },
        { label: '处理失败数量', param: 'registTime', align: 'center' },
        { label: '创建时间', param: 'registTime', align: 'center' },
        { label: '操作人', param: 'registTime', align: 'center' },
        ],
    //      tableOption: {
    //     label: '操作',
    //     width: '100',
    //     fixed:'right',
    //     options: [
    //       { label: '下载', type: 'primary', icon: 'el-icon-view', methods: 'preview' },
    //     ]
    //   },
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
       filterInfo: {
        data: {
          name: null,
          age: null,
          count: 0,
          sex: 1,
          date: null,
          dateTime: null,
          range: null
        },
        fieldList: [
          { label: '文件名称', type: 'input', value: 'name' },
          { label: '类型', type: 'select', value: 'type' ,list: 'typeList'},
        //   { label: '计数', type: 'inputNumber', value: 'count', min: 1, max: 10 },
          { label: '处理状态', type: 'select', value: 'status', list: 'statusList' },
        //   { label: '日期', type: 'date', value: 'date' },
        //   { label: '创建时间', type: 'date', value: 'dateTime', dateType: 'datetime', clearable: true  },
          { label: '创建时间', type: 'date', value: 'range', dateType: 'daterange' }
        ],
        /**搜索/重置区域是否隐藏 */
        // btnHidden: true,
        /**组件尺寸 */
        // size: 'small',
        /**默认展示搜索条件 */
        count: 100,
        /**label/item 宽度 */
        // width: {
        //   labelWidth: 110,
        //   itemWidth: 220
        // },
        /**配置项 */
        btnStyle: [
          { icon: 'el-icon-search', text: '过滤',type: 'primary' },
          { icon: 'el-icon-refresh', text: '重置' }
        ]
      },
      listTypeInfo: {
        statusList: [
          { id: 1, name: '全部' },
          { id: 2, name: '成功' },
          { id: 3, name: '失败' },
        ],
        typeList:[
            {id:1,name:'全部'},
            {id:2,name:'商品批量新增'},
            {id:3,name:'商品批量修改'},
            {id:4,name:'协议价批量调价'}
        ]
      }
    };
  },

  components: {
    eSearch,tableList
  },
  computed:{},

 created() {
     this.tableLabel.map(item => {
console.log(item.label)
     })

 },
 methods:{}
}

</script>
<style lang='scss' scoped>
.container {
  margin-bottom: 10px;
  .sku-img{
    width: 70px;
    height: 70px;
  }
}
.handle-box {
  //   margin-bottom: 20px;
}
</style>
